import { normalizeRecord, PERIOD_STATUS_LABEL } from "./employeeTimelineLayout";
import { formatPayRangeLine } from "./employeeTimelinePayRange";
import { formatFairPayDate } from "@components/utils/fairPayFormat";

export function formatTooltipTitle(record) {
  return normalizeRecord(record).label;
}

export function formatTooltipDescription(record) {
  const normalized = normalizeRecord(record);
  const status =
    normalized.meta?.statusLabel ??
    PERIOD_STATUS_LABEL[normalized.state] ??
    normalized.state.charAt(0).toUpperCase() + normalized.state.slice(1);
  const statePart = normalized.workflowState
    ? `${status} · ${normalized.workflowState}`
    : status;
  const from = formatFairPayDate(normalized.effectiveFrom) || "—";
  const openEnded = normalized.effectiveTo == null || normalized.effectiveTo === "";
  const to = openEnded ? "—" : formatFairPayDate(normalized.effectiveTo) || "—";
  const rangeLine = formatPayRangeLine(normalized);
  const positionLine = normalized.meta?.positionCode
    ? `Position: ${normalized.meta.positionCode}\n`
    : "";
  const dates = `${positionLine}${statePart}\nEffective from: ${from}\nEffective to: ${to}`;
  return rangeLine ? `${dates}\n${rangeLine}` : dates;
}
